import { MissionControlSidebar } from '@vitvio/mission-control';
import { Page, Layout } from '@vitvio/navigation';
import { ORConsoleDetail, ORConsoleHeader } from '@vitvio/or-console';
import { useParams } from 'react-router-dom';

export function ORConsolePage() {
  const { id } = useParams();

  if (!id) {
    return <div>No surgery ID provided</div>;
  }

  return (
    <Page title="OR Console">
      <Layout topbarHeader={<ORConsoleHeader />} sidebar={<MissionControlSidebar />} appName="platform">
        <ORConsoleDetail surgeryId={id} />
      </Layout>
    </Page>
  );
}
